/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Icon } from '@ssmm/ui';
import { colors } from 'components/landing/ui';

import { modList } from '../../../settings';

const ItemElement = styled('div')(({ active }) => ({
  width: 60,
  height: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  borderStyle: 'solid',
  borderWidth: 1,
  background: active ? colors.green : '#fff',
  borderColor: active ? colors.green : colors.grayLight,
  i: { color: active ? '#fff' : '#000', fontSize: 30 },
  cursor: 'pointer',
  pointerEvents: active ? 'none' : 'all',
  ':hover': { background: colors.green, borderColor: colors.green, i: { color: '#fff' } },
}));

const Item = ({ iconType, ...rest }) => (
  <ItemElement {...rest}>
    <Icon type={iconType} set="boss" />
  </ItemElement>
);

const Menu = ({ currentModuleId, selectModule }) => (
  <div
    css={{
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 30,
      '>div:not(:last-of-type)': { marginRight: 25 },
      '@media (min-width:992px)': { justifyContent: 'flex-start' },
    }}
  >
    {Object.keys(modList).map(id => {
      const { iconType, title } = modList[id];

      return (
        <Item
          key={id}
          title={title}
          iconType={iconType}
          active={id === currentModuleId}
          onClick={() => selectModule(id)}
        />
      );
    })}
  </div>
);

export default Menu;
